(function() {
  function parseMap(el) {
    try { return JSON.parse(el.getAttribute('data-variant-map') || '{}'); }
    catch(e) { return {}; }
  }

  function toIndex(map, id) {
    var idx = map[String(id)] != null ? map[String(id)] : map[Number(id)];
    return typeof idx === 'number' ? idx : null;
  }

  function getSwipers(section) {
    // Collect any Swiper instances inside this section and return them
    var swipers = [];
    section.querySelectorAll('.swiper').forEach(function(el) {
      if (el.swiper) swipers.push(el.swiper);
    });
    return swipers;
  }

  function slideAll(swipers, index) {
    swipers.forEach(function(sw) {
      try { sw.slideTo(index); } catch(e) {}
    });
  }

  function waitForSwipers(section, cb, tries) {
    var attempts = typeof tries === 'number' ? tries : 20;
    var tick = function left() {
      var sws = getSwipers(section);
      if (sws.length > 0) return cb(sws);
      if (attempts-- <= 0) return;
      requestAnimationFrame(tick);
    };
    tick();
  }

  function bindForSection(section) {
    var map = parseMap(section);
    if (!map || Object.keys(map).length === 0) return;

    function maybeSlide(rawId) {
      var idx = toIndex(map, rawId);
      if (idx == null) return;
      waitForSwipers(section, function(swipers) {
        slideAll(swipers, idx);
      });
    }

    // Online Store v2 event names
    document.addEventListener('variant:change', function(e) {
      var v = e && e.detail && e.detail.variant;
      if (v && v.id) maybeSlide(v.id);
    });

    document.addEventListener('product:variant-change', function(e) {
      var v = e && e.detail && e.detail.variant;
      if (v && v.id) maybeSlide(v.id);
    });

    // Fallback listener on the nearest product form
    var form = section.closest('[data-product-form]') || document.querySelector('form[action^="/cart/add"]');
    if (form) {
      form.addEventListener('change', function() {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.value) maybeSlide(idInput.value);
      });
    }

    // First load sync from URL or current input
    var params = new URLSearchParams(window.location.search);
    if (params.has('variant')) maybeSlide(params.get('variant'));
    requestAnimationFrame(function() {
      var idInput = form && form.querySelector('input[name="id"]');
      if (idInput && idInput.value) maybeSlide(idInput.value);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-variant-map]').forEach(bindForSection);
  });
})();